import axios from "axios";
import { apiPrefix } from "../config";

axios.interceptors.response.use((response) => {
  return response.data;
});

const request = axios.create({
  baseURL: apiPrefix,
  timeout: 5000,
});

request.interceptors.request.use((request) => {
  const spotId = window.sessionStorage.getItem("spotId");
  const { method, params, data } = request;
  if (method === "get") {
    return {
      ...request,
      params: {
        ...params,
        token: spotId,
      },
    };
  }
  return {
    ...request,
    data: {
      ...data,
      token: spotId,
    },
  };
});

request.interceptors.response.use((response) => {
  return response.data;
});

export const getTickets = () => request("/website/tickets");

export const getTicketDetail = (id) => request(`/website/tickets/${id}`);

// export const getTicketDetailStorage = (id, date) =>
//   request(`/website/seats/${id}?use_date=${date}`);

export const createOrder = (data) => request.post("/website/pay", { data });

export const getOrderStatus = (id) => request(`/website/get_status/${id}`);

export const getSmsVerCode = (tel) =>
  request(`/sms/aliyun_verificationcode?tel=${tel}`);

export const getPayoffInfo = () => request("/website/set");
